import '../../styles/libs/magnific-popup.css'
import '../libs/jquery.magnific-popup.min'
import companyCommon from "@modules/company-common";

const $historyItem = $('.d-company-teams-item');
const $skeletons = $('[data-company-skeleton]')
$(window).on('load', function(e) {
  setTimeout(function() {
    $historyItem.removeClass('_hidden');
    $skeletons.hide()
  }, 100)
})


const $itemInfo = $('[data-team-info]');
$itemInfo.on('click', function () {
  const data = $(this).data('team-info')
  const tpl = `
    <div class="d-company-teams-popup" data-team-info-popup="data-team-info-popup">
      <button class="d-company-teams-popup__close d-button _close _blue _small" data-team-info-close="data-team-info-close">
        <img src="/assets/blueant/assets/img/d/icon_close.svg" />
      </button>
      <div class="d-company-teams-popup__top">
        <div class="d-company-teams-item _popup">
          <div class="d-company-teams-item__img">
            <img alt="" src="${data.img}" />
          </div>
          <div class="d-company-teams-item__content">
            <div class="d-company-teams-item__name">${data.name}</div>
            <div class="d-company-teams-item__post">${data.post}</div>
          </div>
        </div>
      </div>
      <div class="d-company-teams-popup__content" data-simplebar="data-simplebar">
        <div class="d-company-teams-popup__contentInner" data-simplebar="data-simplebar">${data.content}</div>
      </div>
    </div>
  `
  $.magnificPopup.open({
    showCloseBtn: false,
    items: {
      src: tpl,
      type: 'inline'
    },
    fixedContentPos: true,
    callbacks: {
      open: function () {
        const $content = this.content;
        const $closeBtn = $content.find('[data-team-info-close]');
        $closeBtn.on('click', () => {
          this.close()
        });
      },
    }
  }, 0);
})
companyCommon();